export default "__VITE_ASSET__BOUJsYmk__"